import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color } from '@metro-ui/tokens/js';
import { Layout } from '../../Layout';
export var SidebarMenu = styled(/** @class */ (function (_super) {
    __extends(SidebarMenu, _super);
    function SidebarMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { activeIndex: 0 };
        _this.activeRef = React.createRef();
        _this.onKeyDown = function (e) {
            var activeIndex = _this.state.activeIndex;
            var _a = _this.props, children = _a.children, onKeyDown = _a.onKeyDown;
            var length = React.Children.count(children);
            switch (e.key) {
                case 'ArrowDown':
                case 'Down':
                    _this.setState({ activeIndex: (activeIndex + 1) % length });
                    break;
                case 'ArrowUp':
                case 'Up':
                    _this.setState({ activeIndex: (activeIndex - 1 + length) % length });
                    break;
                default:
            }
            if (onKeyDown)
                onKeyDown(e);
        };
        return _this;
    }
    SidebarMenu.prototype.componentDidUpdate = function (_, prevState) {
        var activeIndex = this.state.activeIndex;
        if (prevState.activeIndex !== activeIndex &&
            this.activeRef &&
            this.activeRef.current) {
            this.activeRef.current.focus();
        }
    };
    SidebarMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["label", "className", "children"]);
        var activeIndex = this.state.activeIndex;
        return (React.createElement(Layout, __assign({}, htmlAttributes, { onKeyDown: this.onKeyDown, role: "menubar", "aria-orientation": "vertical", "aria-label": label, direction: "column", className: className }), React.Children.map(children, function (child, index) {
            if (index === activeIndex) {
                var element = child;
                if (React.isValidElement(element)) {
                    element = React.cloneElement(element, {
                        tabIndex: 0,
                        ref: _this.activeRef,
                    });
                }
                return element;
            }
            return child;
        })));
    };
    return SidebarMenu;
}(React.Component)))(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    height: 100%;\n  "], ["\n    background-color: ", ";\n    height: 100%;\n  "])), color.brand.primary.default); });
SidebarMenu.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=SidebarMenu.js.map